<template>
  <div style="display: flex; flex-direction: column">
    <el-checkbox v-model="job.dischargingPortDoor" @change="onChange('dischargingPortDoor')">{{ $t('SeaExport.DispatchVehiclesAtDestination') }}</el-checkbox>
    <el-checkbox v-model="job.usCustomsClearance" @change="onChange('usCustomsClearance')">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
    <el-checkbox v-model="job.destPortCustomsClearance" @change="onChange('destPortCustomsClearance')">{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}</el-checkbox>
  </div>
</template>

<script>
export default {
  name: 'SePortOfDestinationServices',
  props: {
    job: { type: Object, default: () => { return {} } }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
